import { html, LitElement, unsafeCSS } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { PaymentTeaserIconName, type PaymentTeaserItemProp } from '../../../app/package/base/types';
import { I18n } from '../../base/package/services/package/i18n/i18n.de';
import styles from './ui-payment-teaser-item.css?inline';
import '../icons/payment/ui-apple-pay-icon';
import '../icons/payment/ui-google-pay-icon';
import '../icons/payment/ui-klarna-icon';
import '../icons/payment/ui-mastercard-icon';
import '../icons/payment/ui-paypal-icon';
import '../icons/payment/ui-paysafe-icon';
import '../icons/payment/ui-skrill-icon';
import '../icons/payment/ui-skrillonetap-icon';
import '../icons/payment/ui-trustly-icon';
import '../icons/payment/ui-visa-icon';

const CName = 'ui-payment-teaser-item';

@customElement(CName)
export class UIPaymentTeaserItem extends LitElement {
  static readonly styles = unsafeCSS(styles);

  @property({ type: String }) class = '';
  @property({ type: Object }) item: PaymentTeaserItemProp;

  render() {
    return html`
      <div class="payment-teaser-item ${this.class}">
        <div class="icon">${this._renderIcon(this.item.icon)}</div>
        <div class="wrapper">
          <div class="title">${this.item.title}</div>
          <div class="description">${this.item.description}</div>
        </div>
      </div>
    `;
  }

  private _renderIcon(iconName: PaymentTeaserIconName) {
    const label = window.$app.$t.get(I18n.a11y.image.paymentMethod, { name: this.item.title });
    switch (iconName) {
      case PaymentTeaserIconName.PAYPAL:
        return html`<ui-paypal-icon .label=${label}></ui-paypal-icon>`;
      case PaymentTeaserIconName.KLARNA:
        return html`<ui-klarna-icon .label=${label}></ui-klarna-icon>`;
      case PaymentTeaserIconName.PAYSAFECARD:
        return html`<ui-paysafe-icon .label=${label}></ui-paysafe-icon>`;
      case PaymentTeaserIconName.MASTERCARD:
        return html`<ui-mastercard-icon .label=${label}></ui-mastercard-icon>`;
      case PaymentTeaserIconName.VISA:
        return html`<ui-visa-icon .label=${label}></ui-visa-icon>`;
      case PaymentTeaserIconName.TRUSTLY:
        return html`<ui-trustly-icon .label=${label}></ui-trustly-icon>`;
      case PaymentTeaserIconName.SKRILL:
        return html`<ui-skrill-icon .label=${label}></ui-skrill-icon>`;
      case PaymentTeaserIconName.SKRILL_ONE_TAP:
        return html`<ui-skrillonetap-icon .label=${label}></ui-skrillonetap-icon>`;
      case PaymentTeaserIconName.APPLEPAY:
        return html`<ui-apple-pay-icon .label=${label}></ui-apple-pay-icon>`;
      case PaymentTeaserIconName.GOOGLEPAY:
        return html`<ui-google-pay-icon .label=${label}></ui-google-pay-icon>`;
      default:
        return html`<ui-paypal-icon .label=${label}></ui-paypal-icon>`;
    }
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [CName]: UIPaymentTeaserItem;
  }
}
